

























































































import { Component, Prop, Vue, Watch, Emit } from 'vue-property-decorator';
import { institutionServer, userServe } from '@/api/installServer';
import { arrayToTree } from '@/util/array';
import { deepClone } from '@/util/deepClone';

@Component({
  components: {},
})
export default class ChoosePeople extends Vue {
  private deptNameText: any = ''; // 部门名称

  private visible = false; // 弹框显示
  private isVisible = true; // 部门 、 人员显示
  private input: any = ''; // 人员名称搜索
  private showText: any = false;
  private checkedInnerText: any = [];
  private isCheckedId: any = '';

  private cities: any = []; // 部门数据

  private innerCities: any = []; // 人员数据
  private getList() {
    institutionServer
      .getAllData({})
      .then((res: any) => {
        this.cities = arrayToTree(res.data);
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * 打开窗口
   */
  private async showDialog(data: any) {
    this.getList();
    this.visible = true;
    const arr: any = deepClone(data);
    this.checkedInnerText = arr;
  }

  selectionRow(selection: any, row?: any) {
    // this.checkedInnerText = [];
    // (this.$refs.multipleInnerTable as any).clearSelection();
    const selected = selection.length && selection.indexOf(row) !== -1; //为true时选中，为 0 时（false）未选中
    if (selected) {
      // (this.$refs.multipleInnerTable as any).toggleRowSelection(row, true);
      // if (this.checkedInnerText.length > 9) {
      //   this.$message.warning('最多同时选10个');
      //   return;
      // }
      this.checkedInnerText.push(row);
    } else {
      this.checkedInnerText.forEach((re: any, index: any) => {
        if (row.id === re.id) {
          this.checkedInnerText.splice(index, 1);
        }
      });
    }
  }

  /**
   * 关闭窗口
   */
  private hideDialog() {
    this.close();
  }

  /**
   * 【表单】弹窗关闭
   */
  private close() {
    this.showText = false;
    this.visible = false;
    this.isVisible = true;
    this.checkedInnerText = [];
    this.isCheckedId = '';
    this.deptNameText = '';
    this.input = '';
    (this.$refs.multipleInnerTable as any).clearSelection();
  }

  private save() {
    let dataArr: any = [];
    if (this.checkedInnerText.length > 0) {
      this.checkedInnerText.forEach((item: any) => {
        dataArr.push({
          id: item.id,
          name: item.name,
        });
      });
    } else {
      dataArr = [];
    }
    this.$emit('getCheckDeptStaffMoreData', dataArr);
    this.hideDialog();
  }

  /**
     @description: 对下级已选的数据进行删除
     @author: cxf
     @update: cxf 2021/7/12 15:15
     **/
  private handleCloseTag(data: any, index: any) {
    this.checkedInnerText.splice(index, 1);
    this.innerCities.forEach((elem: any) => {
      if (data.id === elem.id) {
        (this.$refs.multipleInnerTable as any).toggleRowSelection(elem, false);
      }
    });
  }

  private nextList(data: any) {
    this.deptNameText = data.name;
    this.isCheckedId = data.id;
    this.getStaffList();
  }
  private getStaffList() {
    userServe.getPageDataAll({ deptId: this.isCheckedId, search: this.input ? this.input : null }).then((res: any) => {
      if (res.code === '200') {
        this.innerCities = res.data;
        if (res.data.length === 0) {
          this.$message.warning('暂无人员');
        } else {
          this.showText = true;
          this.isVisible = false;
          setTimeout(() => {
            this.checkedInnerText.forEach((item: any) => {
              this.innerCities.forEach((elem: any) => {
                if (item.id === elem.id) {
                  (this.$refs.multipleInnerTable as any).toggleRowSelection(elem, true);
                }
              });
            });
          }, 100);
        }
      }
    });
  }

  private searchStaff() {
    this.getStaffList();
  }

  /**
   * 自定义保存姓名
   */
  private formData: any = {};
  private commitName() {
    this.checkedInnerText.push({
      id: '',
      name: this.formData.name,
    });
    this.formData.name = '';
  }
}
